// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const Youtube: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="31" height="21" viewBox="0 0 31 21">
            <path
                d="M29.2426119,3.28578949 C28.8991194,1.99242878 27.8870735,0.973820686 26.6020808,0.628140211 C24.2729387,0 14.9333525,0 14.9333525,0 C14.9333525,0 5.59382129,0 3.26462579,0.628140211 C1.97963309,0.973874092 0.967586398,1.99242878 0.62409389,3.28578949 C0,5.63007879 0,10.5212188 0,10.5212188 C0,10.5212188 0,15.4123588 0.62409389,17.7566481 C0.967586398,19.0500071 1.97963309,20.0261793 3.26462579,20.3718581 C5.59382129,21 14.9333525,21 14.9333525,21 C14.9333525,21 24.2728837,21 26.6020792,20.3718598 C27.8870702,20.0261793 28.8991194,19.0500088 29.2426119,17.7566481 C29.8667049,15.4123588 29.8667049,10.5212188 29.8667049,10.5212188 C29.8667049,10.5212188 29.8667049,5.63007879 29.2426119,3.28578949 Z M11.8787832,14.962008 L11.8787832,6.08042955 L19.684823,10.5213289 L11.8787832,14.962008 L11.8787832,14.962008 Z"
                transform="translate(.817)"
            />
        </svg>
    );
};

export default React.memo(Youtube);
